module.exports = __webpack_public_path__ + "img/aca34c8.jpg";